/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { Grid,Divider } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { addNewBulkCampaign } from '../../services/bulkEmailServices';
import AddNewBulkEmailForm from './AddNewBulkEmailForm';
import type { NewBulkEmailCampaignInputs } from './AddNewBulkEmailForm';
import BulkEmailSummary from './BulkEmailSummary';
import { UNKNOWN_ERR } from 'src/constants/constant';
import BulkEmailImportCSV from './BulkEmailImportCSV';
import BulkEmailReview from './BulkEmailReview';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { CircleArrowLeft01Icon } from '@hugeicons-pro/core-duotone-rounded';
import { checkEventPermission } from 'src/common/utility/utility';
const steps = ['Import', 'Schedule', 'Review', 'Confirmation'];

export interface AddNewBulkEmailFormRef {
  getFormData: () => NewBulkEmailCampaignInputs | null;
  validateForm: () => boolean;
}

function NewBulkCampaign(): JSX.Element {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [sourceCSVFileName, setSourceCSVFileName] = useState<string>('');
  const [uploadedCSVFileName, setUploadedCSVFileName] = useState<string>('');
  const [bulkEmailData, setBulkEmailData] = useState<NewBulkEmailCampaignInputs | null>(null);
  const formRef = useRef<AddNewBulkEmailFormRef>(null);
  const [activeStep, setActiveStep] = React.useState(0);
  const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false);
  const [bulkCampaignDataIdentifier, setBulkCampaignDataIdentifier] = React.useState(0);
  const [selectedSeedList, setSelectedSeedList] = useState<any>(null);
  const [selectedSuppressionList, setSelectedSuppressionList] = useState<any>(null);
  const [selectedSeedListName, setSelectedSeedListName] = useState<string>('');
  const [selectedSuppressionListName, setSelectedSuppressionListName] = useState<string>('');
  // New state to store the same data for summary page
  const [summaryData, setSummaryData] = useState<any>(null);
  const [bulkCampaignTotalCount, setBulkCampaignTotalCount] = React.useState(0);
  const [emailsSuppressedCount, setEmailsSuppressedCount] = useState<number>(0);
  const [emailsUploadedCount, setEmailsUploadedCount] = useState<number>(0);
  const [seedDataCount, setSeedDataCount] = useState<number>(0);
  // Function to handle file upload success from child component
  const handleFileUploadSuccess = (uploadData: any): void => {
    console.log('File upload successful:', uploadData);
    setIsFileUploaded(true);
    setSourceCSVFileName(uploadData.sourceCSVFileName);
    setUploadedCSVFileName(uploadData.uploadedCSVFileName);
    setBulkCampaignDataIdentifier(uploadData.bulkCampaignDataIdentifier);
  };

  // Function to handle file removal from child component
  const handleFileRemoval = (): void => {
    setIsFileUploaded(false);
    setSourceCSVFileName('');
    setUploadedCSVFileName('');
    setBulkCampaignDataIdentifier(0);
    setEmailsUploadedCount(0);
  };

  const handleNext = async (): Promise<void> => {
    // Step 0: Import
    if (activeStep === 0) {
      if (!isFileUploaded) {
        NotificationManager.error('Please upload a CSV file before proceeding');
        return;
      } else if (bulkCampaignTotalCount === 0) {
        NotificationManager.error('There are no valid records in the uploaded CSV');
        return;
      }
      setActiveStep(1);
      return;
    }

    // Step 1: Schedule - validate form
    if (activeStep === 1) {
      if (formRef.current) {
        const isValid = await formRef.current.validateForm();  // ✅ await here
        if (isValid) {
          const formData = await formRef.current.getFormData(); // ✅ await here too
         
          console.log('✅ Form is valid, data:', formData);
          //@ts-ignore
          setBulkEmailData({
            ...formData,
            seedListName: selectedSeedListName,
            suppressionListName: selectedSuppressionListName,
          });
          setActiveStep(2);
        } else {
          console.log('❌ Form validation failed');
          NotificationManager.error('Please fill in all required fields');
        }
      }
      return;
    }

    // Step 2: Review - Final submission
    if (activeStep === 2) {
      if (bulkEmailData) {
        await handleFormSubmit(bulkEmailData);
      }
      return;
    }
  };

  const handleBack = (): void => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleCancel = (): void => {
    navigate('/bulk-email');
  };

  const handleSeedListChange = (seedList: any[]): void => {
    console.log('📋 Seed List changed:', seedList);
    const seedListIds = seedList && seedList.length > 0
    ? seedList.map((s: any) => s.id).join(",")
    : "";
    const seedListNames = seedList && seedList.length > 0 
    ? seedList.map((s: any) => s.name).join(",") 
    : "";
    setSelectedSeedList(seedListIds);
    setSelectedSeedListName(seedListNames);
  };   

  const handleSuppressionListChange = (suppressionList: any[]): void => {
    console.log('📋 Suppression List changed:', suppressionList);
    const suppressionListIds = suppressionList && suppressionList.length > 0
    ? suppressionList.map((s: any) => s.id).join(",")
    : "";
    const suppressionListNames = suppressionList && suppressionList.length > 0 
    ? suppressionList.map((s: any) => s.name).join(",") 
    : "";
    setSelectedSuppressionList(suppressionListIds);
    setSelectedSuppressionListName(suppressionListNames);
  };

  const handleFormSubmit = async (data: NewBulkEmailCampaignInputs): Promise<void> => {
    console.log('Final form submission with data:', data);
    setLoading(true);
    
    try {
      const userData = JSON.parse(localStorage.getItem('user') ?? '{}');
      const seedListId = selectedSeedList;
      const suppressionListId = selectedSuppressionList;

      console.log("Seed:", seedListId, typeof seedListId);
      console.log("Suppression:", suppressionListId, typeof suppressionListId);
      // Prepare the payload for the API
      const emailBulkData = {
        clientId: userData?.clientId ?? 0,
        templateId: data?.templateId,
        unsubscribeTypeId: 2,
        priority: data?.priority,
        bulkCampaignDataIdentifier: bulkCampaignDataIdentifier ?? 0,
        bulkCampaignName: data.name,
        bulkCampaignStartDate: data.startDateTime,
        sourceCSVFileName: sourceCSVFileName,
        uploadedCSVFileName: uploadedCSVFileName,
        createdBy: userData?.id || 0,
        resendDateTime: data.resendSchedules ?? [],
        parentId: 0,
        clientCampaignId: data.clientCampaignId ?? null,
        // unsubscribeTypeId:1
      };

      const normalizeValue = (val: unknown): string | null => {
        if (val == null) return null; // handles null & undefined
        if (typeof val === "object") return null; // exclude objects
        const str = String(val).trim();
        return str && str !== "0" ? str : null;
      };

      const normalizedSeed = normalizeValue(seedListId);
      const normalizedSuppression = normalizeValue(suppressionListId);

      if (normalizedSeed) {
        //@ts-ignore
        emailBulkData.seedListId = normalizedSeed;
      }

      if (normalizedSuppression) {
        //@ts-ignore
        emailBulkData.supressionListId = normalizedSuppression;
      }


      const res = await addNewBulkCampaign(emailBulkData);
      if (res.status === 200) {
        if (res.data.result === 1) {          
          // ✅ Just pass the same bulkEmailData to summary page
          setSummaryData({
            ...res.data.data,
            seedListName: selectedSeedListName, 
            suppressionListName: selectedSuppressionListName 
          });
          
          NotificationManager.success('Bulk email created successfully');
          setActiveStep(3);
        } else {
          const errorMsg: any = res.data.messages;

          NotificationManager.error(
            errorMsg.includes('A bulk campaign with the same name already exists') 
              ? 'Bulk email name already exists'
              : UNKNOWN_ERR,
            '',
            5000,
          );
        }
      }
    } catch (error: any) {
      console.error('Error occurred:', error);
      NotificationManager.error('Unknown error has occurred');
    } finally {
      setLoading(false);
    }
  };
const handleTotalRecipientsCalculated = (total: number, seedDataCount: number, emailsSuppressedCount: number, emailsUploadedCount: number): void => {
  console.log('📊 Totals:', { total, seedDataCount, emailsSuppressedCount, emailsUploadedCount });
  setBulkCampaignTotalCount(total);
  setSeedDataCount(seedDataCount);
  setEmailsSuppressedCount(emailsSuppressedCount);
  setEmailsUploadedCount(emailsUploadedCount);
};
  return (   
        <div className="flex justify-between items-center">
          <div className="w-full">
            <div>
              <h1 className="text-2xl text-title font-semibold">
                New Bulk Email
              </h1>

              <Box sx={{ flexGrow: 1 }}>
                {loading && 
                  <div className="flex justify-center items-center relative">
                    <span className="loading loading-spinner text-primary"></span>
                  </div>
                }
                  <div className="campaign-form-container">
                    <Grid>
                      <Box sx={{ width: '60%', marginTop: '10px', mx: 'auto' }}>
                        <Stepper activeStep={activeStep} alternativeLabel>
                          {steps.map((label) => (
                            <Step key={label}>
                              <StepLabel>{label}</StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </Box>
                      
                      <div style={{ marginTop: '40px' }}>
                        <div style={{ display: activeStep === 0 ? 'block' : 'none' }}>
                          <BulkEmailImportCSV 
                            onFileUploadSuccess={handleFileUploadSuccess}
                            onFileRemoval={handleFileRemoval}
                            onSeedListChange={handleSeedListChange}
                            onSuppressionListChange={handleSuppressionListChange}
                            onTotalRecipientsCalculated={handleTotalRecipientsCalculated}
                          />
                        </div>

                        <div style={{ display: activeStep === 1 ? 'block' : 'none' }}>
                          {//@ts-ignore
                          <AddNewBulkEmailForm ref={formRef} bulkCampaignTotalCount={bulkCampaignTotalCount} initialData={bulkEmailData} />
                          }
                        </div>

                        <div style={{ display: activeStep === 2 ? 'block' : 'none' }}>
                          {bulkEmailData && <BulkEmailReview bulkEmailData={bulkEmailData} seedListName={selectedSeedListName} suppressionListName={selectedSuppressionListName} totalRecipientCount={bulkCampaignTotalCount} seedDataCount={seedDataCount} suppressedCount={emailsSuppressedCount} clientCampaignId={bulkEmailData?.clientCampaignId} />}
                        </div>
                        
                        <div style={{ display: activeStep === 3 ? 'block' : 'none' }}>
                          {/* ✅ Pass the same form data used in review page */}
                          {summaryData && <BulkEmailSummary bulkEmailData={summaryData} campaignData = {bulkEmailData} totalRecipientCount={bulkCampaignTotalCount} seedDataCount={seedDataCount} suppressedCount={emailsSuppressedCount} />}
                        </div>
                      </div>

                      {/* Navigation Buttons */}
                   {/* Navigation Buttons */}
{activeStep !== 3 && (
  <>
  
  <Divider sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '30px' }} />
  <div className="flex justify-between items-center mt-6">
    {/* Left: Cancel */}
    <OutlineButton
      color="gray"
      onClick={handleCancel}
    >
      Cancel
    </OutlineButton>

    {/* Right: Back + Next */}
    <div className="flex gap-2">
      {activeStep !== 0 && (
        <button
            type="button"
            onClick={handleBack}
            style={{
              background: 'none',
              border: 'none',
              color: '#666',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '8px 16px',
              fontSize: '14px',
            }}
        >
          <span style={{ color: '#666' }}>←</span> Back
        </button>
       
      )}

      <GradientButton
        color="red"
        onClick={() => void handleNext()}
        width="150px"
         disabled={
           (activeStep == 2 && !checkEventPermission('BULKEMAIL_ADD')) || (emailsUploadedCount === 0 && activeStep === 0) 
          }
          >
        {activeStep === 0
          ? 'Next: Schedule >'
          : activeStep === 1
          ? 'Next: Review'
          : activeStep === 2 
          ? 'Create'
          : 'Next'}
      </GradientButton>
    </div>
  </div>
  </>
)}


                    </Grid>
                  </div>
               
              </Box>
            </div>
          </div>
        </div>
  );
}

export default NewBulkCampaign;